<template>
  <ScCard class="unauthorized-wrapper">
    <template #body>
      <div class="card-body">
        <div class="header-wrapper">
          <div class="left">
            <span class="title">
              {{ $t(isFromDashboard ? 'unauthorized.titleForDashboard':'unauthorized.title') }}
            </span>
            <div class="messages">
              <span
                v-if="!isFromDashboard && !unauthorizedSupplier"
                class="message-3"
                v-html="$t('unauthorized.message3', { link: unauthorizedLink })"
              />
              <span
                class="message-1"
                v-html="$t('unauthorized.message1')"
              />
              <span
                class="message-2"
                v-if="isFromDashboard"
              >
                {{ $t('unauthorized.message2') }}
              </span>
            </div>
          </div>
          <div class="right">
            <img
              class="unauthorized-icon"
              src="https://cdn.dsmcdn.com/seller-center/account/images/unauthorized.svg"
              alt="unauthorized-icon"
            >
          </div>
        </div>
        <div class="content-wrapper">
          <ScThreeDots v-if="loading" />
          <MenuList
            :menu-items="menuItems"
            v-else
          />
        </div>
      </div>
    </template>
  </ScCard>
</template>

<script>
import ScCard from '@trendyol/sc-ui-kit/ScCard';
import ScThreeDots from '@trendyol/sc-ui-kit/ScThreeDots';
import MenuList from './MenuList';
export default {
  name: 'Unauthorized',

  components: {
    MenuList,
    ScCard,
    ScThreeDots,
  },

  data () {
    return {
      menuItems: [],
      loading: false,
    };
  },

  created () {
    if (typeof window.getMenuItems !== 'function') {
      this.loading = true;
    } else {
      this.menuItems = window.getMenuItems() || [];
    }

    window.scEventBus.subscribe('MENU_ITEMS', (menuItems) => {
      this.menuItems = menuItems;

      this.loading = false;
    });

    if (this.isFromDashboard) {
      this.$router.replace({
        name: 'Dashboard',
        params: {
          isFromDashboard: this.isFromDashboard,
        },
      });
    } else if (Object.keys(this.$route.query).length) {
      this.$router.replace({
        params: {
          unauthorizedLink: this.unauthorizedLink,
          unauthorizedSupplier: this.unauthorizedSupplier,
        },
        query: {},
      });
    }
  },

  computed: {
    unauthorizedSupplier () {
      return this.$route.params.unauthorizedSupplier || this.$route.query.unauthorizedSupplier;
    },

    unauthorizedLink () {
      return this.$route.params.unauthorizedLink || this.$route.query.unauthorizedLink;
    },

    isFromDashboard () {
      if (this.$route.params.isFromDashboard) {
        return true;
      }
      try {
        return (new URL(this.unauthorizedLink)).pathname === '/dashboard';
      } catch (e) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .unauthorized-wrapper {
    padding: 30px;

    .header-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        flex-direction: column;
      }

      .left .title {
        color: #f27a1a;
        font-size: 20px;
        font-weight: 500;
      }

      .left .messages {
        margin-top: 10px;
      }

      ::v-deep .left .messages a {
        color: #f27a1a;
      }

      .left .messages span:last-child {
        margin-top: 10px;
      }

      .left .messages span {
        font-size: 14px;
        display: block;
      }

      .right .unauthorized-icon {
        min-height: 120px;
        height: 120px;
        max-height: 120px;
      }
    }

    @media only screen and (max-width:640px) {
      .header-wrapper {
        flex-direction: column;

        .right .unauthorized-icon {
          margin-top: 20px !important;
          display: block;
        }
      }
    }
  }
</style>
